module.exports = __webpack_public_path__ + "r-v3/img/twolines.9f258084.svg";